// extracted by mini-css-extract-plugin
export var actionButton = "_kv-0";
export var fileInput = "_kv-2";
export var paperclip = "_kv-1";